// "Can't find it" as the office reads it (truck-stock parity 3), kept apart from the screen so it is tested.
import { qtyText } from './model.ts';

/** materialRequests.list's request. */
export interface MaterialRequest {
  id: string;
  staffId: string;
  staffName: string;
  locationId: string | null;
  locationName: string | null;
  jobId: string | null;
  jobNumber: string | null;
  itemId: string | null;
  description: string;
  quantity: string;
  note: string | null;
  requestedAt: string;
  status: 'open' | 'got' | 'not_got';
  handledAt: string | null;
  handledNote: string | null;
  transferId: string | null;
  poId: string | null;
}

/** "2 × A ¾″ ball valve", or the description alone for one. */
export const requestWhat = (r: Pick<MaterialRequest, 'description' | 'quantity'>) =>
  Number(r.quantity) === 1 ? r.description : `${qtyText(r.quantity)} × ${r.description}`;

/** "Sam Rivera · Truck 1 · job #1042": who asked, from which truck, for which job. */
export const requestWho = (r: Pick<MaterialRequest, 'staffName' | 'locationName' | 'jobNumber'>) =>
  [r.staffName, r.locationName ?? 'no truck set up', r.jobNumber ? `job #${r.jobNumber}` : null]
    .filter(Boolean)
    .join(' · ');
